<template>
  <div class="join_result">
    <div class="test">
      <span>尊敬的{{$route.query.customerName}}：</span>
      <p class="indent">
        您的加盟申请我们已经收到，请您耐心等待，我们将尽快与您联系；欢迎您加入多比家具网，我们敬请期待！
      </p>
    </div>
    <el-button class="btn" type="primary" @click="IKnow">我知道了</el-button>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
export default {
  metaInfo: { title: "立即加盟 - 多比商城" },
  name: "joinResult",
  data() {
    return {};
  },
  mounted() {
    // 处理用户名
    // console.log(this.$route.query);
    let contentWidth =
      document.documentElement.clientWidth || document.body.clientWidth;
    let fontSize = (contentWidth * 18) / 375;
    document.documentElement.style.fontSize = fontSize + "px";
    // alert(contentWidth);
  },
  methods: {
    IKnow() {
      // WeixinJSBridge.call('closeWindow');
      wx.closeWindow();
    },
  },
};
</script>

<style lang="less" scoped>
.join_result {
  box-sizing: border-box;
  font-size: 0.875rem;
  text-align: center;
  padding-top: 30%;
  color: #f56c6c;
  .test {
    text-align: left;
    margin-bottom: 6rem;
    padding: 0 5rem;
    word-wrap: break-word;
    .indent {
      text-indent: 1.75rem;
    }
    .icon {
      vertical-align: middle;
      font-size: 1.5rem;
      margin-right: 0.625rem;
    }
  }
  .btn {
    width: 12.25rem;
    letter-spacing: 0.1792rem;
    padding: 0.5rem 1.25rem;
    font-size: 0.875rem;
  }
}
</style>